import { AddonsAccessService } from './addons/addons-subscribtion/addons-access.service'
import { AfterViewInit, Component, OnInit } from '@angular/core'
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router'
import { GoogleAnalyticsService } from 'ngx-google-analytics'
import { environment } from 'src/environments/environment'
import { BlockDataService } from './block-services/block-data.service'
import { BlockFieldsService } from './block-services/block-fields.service'
import { CategoriesService } from './blocks-wrapper/block-categories/categories.service'
import { PostsService } from './blocks-wrapper/block-posts/posts.service'
import { ProductsService } from './blocks-wrapper/block-products/products.service'
import { BuilderService } from './builder-services/builder.service'
import { ConnectivityService } from './connectivity/connectivity.service'
import { LoginService } from './login/login.service'
import { MixpanelService } from './tracking/mixpanel.service'
import { MatDialog } from '@angular/material/dialog'
import { WorksDialogComponent } from '../app/pages/works-dialog/works-dialog.component'
import { LanguageService } from './language.service'
import { TranslateService } from '@ngx-translate/core'
import { PluginsServiceService } from './plugins-loader/plugins-service.service'
import { OrderNotificationService } from './e-commerce/orders/order-notification-service/order-notification.service'
import { SubscriptionFlowService } from './subscription-flow/subscription-flow.service'
import { Observable } from 'rxjs'
import { skip, take } from 'rxjs/operators'
import { HelpersService } from './helpers.service'
import { ProtectedImagesService } from 'src/app/protected-images.service'
import { AppUsersService } from 'src/app/app-users/services/app-users.service'
import { VendorService } from './multivendor/vendor.service'
import { AppSettingsService } from './settings/services/app-settings.service'
import { DomainService } from './domain/services/domain.service'
import { SettingsService } from './e-commerce/settings/settings.service'
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit, OnInit {
  args: object = {
    categories: [],
    hide_empty: true,
    orderby: 'date',
    order: 'DESC',
    source: 'by_id'
  }

  mobile = false
  translatedText!: string
  currentPage: any
  constructor(
    public builderService: BuilderService,
    public loginService: LoginService,
    private router: Router,
    private route: ActivatedRoute,
    public subscriptionFlow: SubscriptionFlowService,
    public LanguageService: LanguageService,
    private translate: TranslateService,
    private dialog: MatDialog,
    private categoriesService: CategoriesService,
    protected gaService: GoogleAnalyticsService,
    public blockDataService: BlockDataService,
    public connectivity: ConnectivityService,
    public mixPanel: MixpanelService,
    public postsService: PostsService,
    public productsService: ProductsService,
    private blockFields: BlockFieldsService,
    private pluginsService: PluginsServiceService,
    private orderNotificationService: OrderNotificationService,
    private addonsAccess: AddonsAccessService,
    private protectedImagesService: ProtectedImagesService,
    private appUsersService: AppUsersService,
    private vendor:VendorService,
    private helpers: HelpersService,
    private appSettingsService: AppSettingsService,
    private domainService: DomainService,
    private settingsService: SettingsService
  ) {
    if (window.screen.width <= 768) {
      // 768px portrait
      this.mobile = true
    }

    this.blockDataService.getTokenData().subscribe((token) => {
      this.blockDataService.getProjectData().subscribe((projectId) => {
        // Check and auto-generate subdomain if it doesn't exist for this project
        this.checkAndGenerateSubdomain(projectId)
        this.settingsService.getCurrencySettings().subscribe()

        // Check the Connectivity of the plugin and if connected then Check the Default Views
        this.connectivity.connectivityChecker()
        this.getInitialTour()
        this.getInitialProjectConfig()
        this.categoriesService.getInitialCategories()
        this.postsService.getInitialCategories()
        this.getProjectStatus(projectId).subscribe((project: any) => {
          this.builderService.restrictedPages = this.helpers.parseAccess(project?.model[0]?.access)?.restricted_pages
          // Get Active Addons (project + account-wide) once they load
          this.addonsAccess.loadSubscriptions()
          this.addonsAccess.getSubscriptions$().pipe(skip(1), take(1)).subscribe(() => {
            // get the active addons route to exclude from the restricted pages
            for (const page of this.builderService.addons_pages_map) {
              if (!page.addon || this.addonsAccess.isAddonActive(page.addon)) {
                this.builderService.restrictedPages = this.builderService.restrictedPages?.filter((item: string) => !page.routes.includes(item))
              }
            }
          })
        })
        this.mixPanel.init(projectId)
        // if( this.builderService.user_type == 'self_ltd' ) {
        // }
        // let allBlocks = this.blockDataService.getAllBlocksData();
        this.getGlobalHeader(projectId)
        this.getGlobalFooter(projectId)

        this.getPosts(this.builderService.getSelectedProject(), this.blockFields.postsBlockData.data)

        this.getProducts(this.builderService.getSelectedProject(), this.blockFields.productsBlockData.data)

        // this.addonsService.fetchAndProcessData().subscribe((active_addons: any) => {
        //   console.log(active_addons)
        // })
      })
    })

    this.builderService.getViews()
    this.builderService.getPages()
    if (environment.production) {
      this.gaService.gtag('config', 'AW-972505779')
      this.gaService.gtag('config', environment.gtm)
    }
  }

  getGlobalHeader = (projectId: any) => {
    this.builderService.getView(99, 'global_header').subscribe((response: any) => {
      // Globals page, pull the data of the globals header
      if (!response || response == undefined || response == null || response == '') {
        // There is no global Footer for this project, submit one
        this.builderService.updateProject(projectId, [this.blockFields.headerBlockData], false, 99, 'global_header').subscribe((result: any) => {
          this.builderService.globalHeader = this.blockFields.headerBlockData
          this.blockDataService.sendGlobalHeader(this.builderService.globalHeader)
        })
      } else {
        let parsedResponse
        if (typeof response == 'string') {
          if (JSON.parse(response)[0]) {
            parsedResponse = JSON.parse(response)[0].allBlocks ? JSON.parse(response)[0].allBlocks : JSON.parse(response)[0]
          } else {
            parsedResponse = JSON.parse(response).allBlocks ? JSON.parse(response).allBlocks : JSON.parse(response)
          }
        } else {
          parsedResponse = response.allBlocks && response.allBlocks[0] ? response.allBlocks[0] : response
        }
        this.builderService.globalHeader = parsedResponse
        this.blockDataService.sendGlobalHeader(this.builderService.globalHeader)
      }
    })
  }

  getGlobalFooter = (projectId: any) => {
    this.builderService.getView(98, 'global_footer').subscribe((response: any) => {
      // Globals page, pull the data of the globals footer
      if (!response || response == undefined || response == null || response == '') {
        // There is no global Footer for this project, submit one
        this.builderService.updateProject(projectId, [this.blockFields.footerBlockData], false, 98, 'global_footer').subscribe((result: any) => {
          this.builderService.globalFooter = this.blockFields.footerBlockData
          this.blockDataService.sendGlobalFooter(this.builderService.globalFooter)
        })
      } else {
        let parsedResponse
        if (typeof response == 'string') {
          if (JSON.parse(response)[0]) {
            parsedResponse = JSON.parse(response)[0].allBlocks ? JSON.parse(response)[0].allBlocks : JSON.parse(response)[0]
          } else {
            parsedResponse = JSON.parse(response).allBlocks ? JSON.parse(response).allBlocks : JSON.parse(response)
          }
        } else {
          parsedResponse = response.allBlocks && response.allBlocks[0] ? response.allBlocks[0] : response
        }
        this.builderService.globalFooter = parsedResponse[parsedResponse.length - 1] ? parsedResponse[parsedResponse.length - 1] : parsedResponse
        this.blockDataService.sendGlobalFooter(this.builderService.globalFooter)
        // if( parsedResponse == undefined || parsedResponse == null || parsedResponse == '' ) {
        //   parsedResponse = response.allBlocks[0].data;
        //   this.builderService.globalFooter = parsedResponse;
        //   this.blockDataService.sendGlobalFooter(this.builderService.globalFooter);
        // } else {
        //   this.builderService.globalFooter = parsedResponse[parsedResponse.length - 1];
        //   this.blockDataService.sendGlobalFooter(this.builderService.globalFooter);
        // }
      }
    })
  }

  getInitialTour = () => {
    /**
     * Get the initial tour status and sets the local value
     */
    this.builderService.getInitialTourStatus().subscribe(
      (tour: any) => {
        let tourStart = tour.data == '1' ? false : true
        this.builderService.setTour(tourStart)
        /**
         * If the tour should start then navigate to it
         */
        if (tourStart) {
          if (this.builderService.projectAccess == 'webview') {
            this.router.navigate(['/site-type'], { relativeTo: this.route })
          }
        }
      },
      (err) => {
        console.log('Initial Tour Error', err)
      }
    )
  }
  closeSidebars = () => {
    if (this.mobile) {
      this.builderService.toggleSidebar = false
      // this.builderService.blocksCollapsed = true;
    }
  }

  ngOnInit() {
    // Handle query params (e.g. ?token=...&genie=true)
    this.route.queryParams.subscribe(params => {
      // Handle genie param
      console.log('Query params received:', params)

      if (params['genie'] === 'true') {
        const projectId = params['projectId'];
        const genieMode = params['genieMode'];
        const importMode = params['importMode'];

        // Store genie mode before potential reload
        if (genieMode) {
          localStorage.setItem('genieMode', genieMode);
        }

        // Store import mode if present (for products import flow)
        if (importMode) {
          localStorage.setItem('importMode', importMode);
        }

        // Token/project from the URL were already persisted to localStorage by main.ts
        // BEFORE Angular bootstrapped, so service constructors read fresh values and
        // the old "reload on token/project change" double-boot is no longer needed.
        console.log('Setting genie mode:', genieMode);
        this.builderService.setGenieMode(true, params);
        this.builderService.setTour(false).subscribe((response) => {
          console.log('Tour disabled for genie mode');
        });
        // sendProjectData is never called in genie mode (projects page doesn't load),
        // so the normal getProjectStatus/setLastLogin pipeline never fires.
        // Call updateUserLastLogin directly with data already available here.
        const genieEmail = this.loginService.getCurrentUser()?.email
        if (genieEmail) {
          this.builderService.getProject(projectId).subscribe((project: any) => {
            const access = project?.details?.[0]?.access
            const isPremium = access === 'full' || access === 'webview'
            this.appUsersService.updateUserLastLogin(isPremium ? 'unlimited' : undefined)
          })
        }
      }

      // Handle lang param from stacks-chat
      if (params['lang']) {
        this.LanguageService.setLanguage(params['lang']);
        this.translate.use(params['lang']);
      }
    });
    this.vendor.loadVendorsOnce()
    this.orderNotificationService.getNewOrderNotification().subscribe((hasNewOrder) => {})

    this.LanguageService.loadTranslations(this.LanguageService.getLanguage()).then(() => {
      // Set the active language for ngx-translate
      this.translate.use(this.LanguageService.getLanguage())
    })
    /**
     * Watch the ruoted pages to control the visibility of header elements
     */
    this.router.events.subscribe((route_event) => {
      if (route_event instanceof NavigationEnd) {
        this.builderService.globals = false
        this.currentPage = route_event.url
        switch (route_event.url) {
          case '/app-basics':
            this.builderService.headerBtn = 'appSettings'
            break
          case '/seosettings':
            this.builderService.headerBtn = 'seosettings'
            break
          case '/firebasesettings':
            this.builderService.headerBtn = 'firebasesettings'
            break
          case '/contentsettings':
            this.builderService.headerBtn = 'contentsettings'
            break
          case '/multilingual':
            this.builderService.headerBtn = 'multilingual'
            break
          case '/txtTranslations':
            this.builderService.headerBtn = 'txtTranslations'
            break
          case '/social':
            this.builderService.headerBtn = 'social'
            break
          case '/pushnotifications':
            this.builderService.headerBtn = 'pushnotifications'
            break
          case '/e-commerce/settings':
            this.builderService.headerBtn = 'e-commerce/settings'
            break
          case '/orders/single-order':
            this.builderService.headerBtn = 'orders/single-order'
            break
          case '/vendors/new-vendor':
            this.builderService.headerBtn = 'vendors/new-vendor'
            break
          case '/points':
            this.builderService.headerBtn = 'points'
            break
          case '/android':
            this.builderService.headerBtn = 'android'
            break
          case '/ios':
            this.builderService.headerBtn = 'ios'
            break
          case '/e-commerce/payments':
            this.builderService.headerBtn = 'paymentSettingsForm'
            break
          case '/integrations':
            this.builderService.headerBtn = 'integrations'
            break
          case '/globals':
            this.builderService.globals = true
            this.builderService.headerBtn = 'globals'
            this.blockDataService.sendSelectedView({ view_name: 'home', view_id: 1, title: 'home' })
            break
          case '/website-builder/edit':
            this.builderService.headerBtn = 'websitePageEditor'
            break
          default:
            // Check if we're on the root path (may include query params)
            if (route_event.url === '/' || route_event.url.startsWith('/?')) {
              this.builderService.headerBtn = 'builderView'
            } else {
              this.builderService.headerBtn = ''
            }
            break
        }

        this.getGlobalHeader(this.builderService.selectedProject)
        this.getGlobalFooter(this.builderService.selectedProject)
        this.gaService.pageView(route_event.url, 'Brickit - ' + route_event.url)
        this.gaService.gtag('config', environment.gtm)
        this.builderService.logData('Navigated to ' + route_event.url, 'builder page navigation', 'Navigated to ' + route_event.url).subscribe(
          (response) => {},
          (err) => {}
        )
      }
    })
    // Save to builder and database
    this.protectedImagesService.setProtectedImages()
    if (this.loginService.getCurrentUser().admin) {
      this.deleteStorageOfDeletedProjects()
    }
  }

  switchLanguage(language: string): void {
    // Set the selected language
    this.LanguageService.setLanguage(language)
    // Load translations for the selected language
    this.LanguageService.loadTranslations(language).then(() => {
      // Set the active language for ngx-translate
      this.translate.use(language)
    })
  }

  async ngAfterViewInit() {
    this.pluginsService.setPluginsServices({})
  }

  getInitialProjectConfig = () => {
    /**
     * Get project Configuration
     */
    this.builderService.getProjectConfig().subscribe(
      (config: any) => {
        if (config !== false) {
          this.blockDataService.woocommerceActive = true
        }
      },
      (err) => {}
    )
  }

  howItWorksDialog = () => {
    const dialogRef = this.dialog.open(WorksDialogComponent, {
      width: '700px',
      maxWidth: '80%',
      data: { name: 'builderHome' }
    })

    dialogRef.afterClosed().subscribe((result) => {
      console.log('The dialog was closed')
    })
  }

  /**
   * Delete Firebase Storage assets for all deleted projects
   * and remove their database keys after successful cleanup
   * @returns void
   */
  deleteStorageOfDeletedProjects = (): void => {
    // deleted_projects cleanup removed: no Supabase equivalent for this Firebase-specific node
  }

  getProjectStatus = (projectId: any, type: string = 'default') => {
    this.builderService.showUpdateProgress = true
    this.builderService.selectedProject = projectId
    return new Observable<any>((observer) => {
      this.builderService.getProject(projectId).subscribe((project: any) => {
        this.setLastLogin(project);
        // Cache the response
        const pricingPackagesByRegion = {
          usd: environment.pricing_packages,
          egypt: environment.egypt_pricing_packages,
          emirates: environment.emirates_pricing_packages,
          saudi: environment.saudi_pricing_packages,
          test: environment.test_pricing_packages
        }
        const foundPackage = Object.values(pricingPackagesByRegion).find((packages) => packages?.some((pkg) => pkg?.pricing_id === JSON.parse(project?.premium?.[0]?.package || '{}')?.price_id))
        // Default to USD if no package is found
        project.package = foundPackage ?? environment.pricing_packages
        if (!project.premium || project.premium.length === 0) {
          project.premium = [
            {
              package: JSON.stringify({
                name: 'Stacks Plans',
                type: 'Growth',
                period: 'quarterly',
                price_id: 'price_1PxrXGDPC5jsdjOinEakBsMg'
              })
            }
          ]
        }
        this.builderService.user_type = project.user_type
        this.builderService.cacheProjectReq.response = project
        this.blockDataService.sendProjectCached(project)
        this.builderService.projectStatus = project.details[0].status
        this.builderService.projectAccess = project.details[0].access
        this.builderService.projectStartDate = project.details[0].start_date
        observer.next(project)
        observer.complete()
      })
    })
  }
  /**
   * Updates the project's `info` section with the latest login metadata.
   * Only proceeds if the current user is not admin. Builds an updated info object
   * containing the project's type, email, status, and a new ISO `lastLogin` timestamp,
   * then writes it to the database at `projects/{projectId}/info`.
   *
   * @param project The project object containing email, details, and project_id.
   */
  setLastLogin(project: any) {
    if (this.loginService.getCurrentUser().admin) return
    const info = {
      access: project.details[0].access ?? 'free',
      email: project.details[0]?.auth_user,
      lastLogin: new Date().toISOString(),
      projects_limit: project.details[0]?.type === 'free' ? 5 : 'unlimited',
      start_date: project.details[0]?.start_date,
      status: project.details[0]?.status,
      type: project.details[0].type ?? 'free'
    }

    this.appSettingsService.upsertSettingsByType(String(project.details[0].project_id), 'info', info)

    const email = this.loginService.getCurrentUser()?.email
    if (email) {
      const access = project.details[0]?.access
      const isPremium = access === 'full' || access === 'webview'
      this.appUsersService.updateUserLastLogin(isPremium ? 'unlimited' : undefined)
    }
  }

  getPosts = (projectId: number, args: object) => {
    this.builderService.showUpdateProgress = true
    this.postsService.getPosts(projectId, args).subscribe(
      (response) => {
        this.blockDataService.sendPostsCached(response)
      },
      (err) => {}
    )
    return true
  }

  getProducts = (projectId: number, args: object) => {
    this.builderService.showUpdateProgress = true
    this.productsService.getProducts(projectId, args).subscribe(
      (response) => {
        this.blockDataService.productsCached = true
        this.builderService.showUpdateProgress = false
        this.blockDataService.sendProductsCached(response)
      },
      (err) => {}
    )
    return true
  }
  /**
   * Clears Token and redirects to login page
   */
  logout = () => {
    this.loginService.logout()
    this.router.navigate(['/login'], { relativeTo: this.route })
  }
  nextTourStep = () => {
    switch (this.currentPage) {
      case '/':
        this.router.navigate(['/products'], { relativeTo: this.route })
        break
      case '/views':
        this.router.navigate(['/products'], { relativeTo: this.route })
        break
      case '/products':
        this.router.navigate(['/products/new-product'], { relativeTo: this.route })
        break
      case '/products/new-product':
        this.router.navigate(['/app-preview'], { relativeTo: this.route })
        break
      case '/app-preview':
        // Demo Completed Popup, now feel free to modify the content that you want
        //
        let dialogRef = this.dialog.open(WorksDialogComponent, {
          width: '700px',
          maxWidth: '80%',
          data: { name: 'tourCompleted' }
        })
        dialogRef.afterClosed().subscribe((result) => {
          // localStorage.setItem('mainScreen_Self_LTD', 'closed');
          this.builderService.setTour(false).subscribe((response) => {
            this.router.navigate(['/'], { relativeTo: this.route })
          })
        })
        break
      default:
        break
    }
  }

  validateTour = () => {
    if (this.currentPage) {
      if (this.currentPage.includes('templates') || this.currentPage.includes('login') || this.currentPage.includes('signup')) {
        return false
      } else {
        return true
      }
    } else {
      return false
    }
  }

  showSidebar = () => {
    if (this.currentPage.includes('templates') || this.currentPage.includes('site-type') || this.currentPage.includes('products') || this.currentPage.includes('app-preview') || this.currentPage.includes('login') || this.currentPage.includes('signup')) {
      return false
    } else {
      return true
    }
  }

  /**
   * Checks if a subdomain exists for the current project and auto-generates one if missing.
   * This ensures existing projects without subdomains get one on app load.
   *
   * @param projectId The project ID to check
   */
  private checkAndGenerateSubdomain(projectId: string): void {
    // First, get the general settings to retrieve the application name
    this.appSettingsService.getGeneralSettings(projectId).subscribe(
      (generalSettings: any) => {
        if (generalSettings && generalSettings.application_name) {
          // Check if subdomain exists
          this.domainService.getDomainSettings(projectId).subscribe(
            (domainSettings) => {
              // Only generate if no subdomain exists yet
              if (!domainSettings || !domainSettings.subdomain) {
                const generatedSubdomain = this.domainService.generateSubdomainFromName(generalSettings.application_name)
                this.domainService.saveSubdomain(projectId, generatedSubdomain).subscribe(
                  (response) => {
                    console.log('Subdomain auto-generated on app load:', response.subdomain_full)
                  },
                  (error) => {
                    console.error('Failed to auto-generate subdomain on app load:', error)
                  }
                )
              }
            },
            (error) => {
              console.error('Failed to check domain settings on app load:', error)
            }
          )
        }
      },
      (error) => {
        console.error('Failed to get general settings on app load:', error)
      }
    )
  }
}
